import loadable from '@loadable/component';

export const LoginPageContainerLoadable = loadable(
  () => import('./LoginPageContainer'),
  { resolveComponent: (module) => module.LoginPageContainer },
);
